import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { AppShell } from "./components/layout/AppShell";
import { LoadingSpinner } from "./components/common/LoadingSpinner";

// Pages
import LoginPage from "./pages/auth/LoginPage";
import ProfileSetupPage from "./pages/auth/ProfileSetupPage";
import HomePage from "./pages/home/HomePage";
import EventsPage from "./pages/events/EventsPage";
import EventDetailPage from "./pages/events/EventDetailPage";
import CreateEventPage from "./pages/events/CreateEventPage";
import PariMutuelPage from "./pages/events/PariMutuelPage";
import FriendsPage from "./pages/friends/FriendsPage";
import ChatPage from "./pages/chat/ChatPage";
import StatsPage from "./pages/stats/StatsPage";
import MorePage from "./pages/more/MorePage";
import DevPage from "./pages/dev/DevPage";
import DevGeneratePariMutuelPage from "./pages/dev/DevGeneratePariMutuelPage";
import GuestJoinPage from "./pages/join/GuestJoinPage";

function ProtectedRoutes() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return <LoadingSpinner fullScreen />;
  if (!isAuthenticated) return <Navigate to='/login' replace />;

  return (
    <AppShell>
      <Routes>
        <Route path='/' element={<HomePage />} />
        <Route path='/events' element={<EventsPage />} />
        <Route path='/events/create' element={<CreateEventPage />} />
        <Route path='/events/:id' element={<EventDetailPage />} />
        <Route
          path='/events/:eventId/parimutuel'
          element={<PariMutuelPage />}
        />
        <Route path='/friends' element={<FriendsPage />} />
        <Route path='/chat' element={<ChatPage />} />
        <Route path='/stats' element={<StatsPage />} />
        <Route path='/more' element={<MorePage />} />
        <Route path='/dev' element={<DevPage />} />
        <Route
          path='/dev/generate-parimutuel'
          element={<DevGeneratePariMutuelPage />}
        />
        <Route path='/profile/setup' element={<ProfileSetupPage />} />
        <Route path='*' element={<Navigate to='/' replace />} />
      </Routes>
    </AppShell>
  );
}

export default function App() {
  return (
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <AuthProvider>
        <Routes>
          <Route
            path='/login'
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            }
          />
          <Route path='/join/:shareCode' element={<GuestJoinPage />} />
          <Route path='/*' element={<ProtectedRoutes />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

function PublicRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) return <LoadingSpinner fullScreen />;
  if (isAuthenticated) return <Navigate to='/' replace />;
  return <>{children}</>;
}
